import { render } from "./SortCategoryProduct.vue?vue&type=template&id=8e4dac5a&ts=true"
import script from "./SortCategoryProduct.vue?vue&type=script&lang=ts"
export * from "./SortCategoryProduct.vue?vue&type=script&lang=ts"

import "./SortCategoryProduct.vue?vue&type=style&index=0&id=8e4dac5a&lang=css"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__